import { LOGIN_URL } from './auth-client.js';

/**
 * The other Ridgewill accounts this browser is signed in to.
 *
 * A browser holds up to four (auth's multiSession, RidgeWill/auth#488; a fifth
 * sign-in signs the oldest out). Listing them and switching between them are
 * the HOT PATH's, at `LOGIN_URL`: the account deployment this portal otherwise
 * talks to deliberately does not serve `/multi-session/*`. The session cookie is
 * shared across `.ridgewill.com`, so a switch made here is the switch everywhere.
 *
 * Same menu as ridgewill.com (ridgewill-site, assets/site/chrome.js): the other
 * accounts under "Signed in as", "Add another account" below four, and one
 * "Sign out" that asks auth's account chooser which account when there are
 * several.
 */

export const MAX_ACCOUNTS = 4;

export interface DeviceAccount {
  session: { token: string };
  user: { id: string; name?: string | null; email: string; image?: string | null };
}

const BASE = `${LOGIN_URL}/api/auth/multi-session`;

/** Every account this browser holds, the active one included. Null when the
 *  list cannot be had, which callers treat as "no switcher", never as an error. */
export async function listDeviceAccounts(): Promise<DeviceAccount[] | null> {
  try {
    const res = await fetch(`${BASE}/list-device-sessions`, { credentials: 'include' });
    if (!res.ok) return null;
    const body: unknown = await res.json();
    return Array.isArray(body) ? (body as DeviceAccount[]) : null;
  } catch {
    return null;
  }
}

/** Make another held account the active one. The caller reloads either way:
 *  the page then shows whichever account the cookie names. */
export async function switchTo(sessionToken: string): Promise<void> {
  try {
    await fetch(`${BASE}/set-active`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ sessionToken }),
    });
  } catch {
    /* reloading shows what is true */
  }
}

/** auth's account chooser, which signs out one account or all of them and then
 *  follows `returnQuery` (`returnTo=...&at=...`) back. */
export function chooserUrl(returnQuery: string): string {
  return `${LOGIN_URL}/accounts?${returnQuery}`;
}
